import { Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const languages = [
  { code: 'tr', label: 'TR' },
  { code: 'en', label: 'EN' },
  { code: 'de', label: 'DE' },
]

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const activeLanguage = i18n.resolvedLanguage || i18n.language

  const changeLanguage = (code) => {
    i18n.changeLanguage(code)
    document.documentElement.lang = code
  }

  return (
    <div className="absolute right-4 top-4 z-50 flex items-center space-x-2 rounded-full border border-gray-700 bg-black/50 p-2 backdrop-blur-md">
      <Languages className="h-4 w-4 text-gold-500" aria-hidden="true" />
      <div className="flex space-x-2" aria-label="Language">
        {languages.map(({ code, label }) => (
          <button
            key={code}
            type="button"
            onClick={() => changeLanguage(code)}
            className={`rounded px-2 py-1 text-xs font-bold transition-colors ${activeLanguage === code ? 'bg-gold-500 text-black' : 'text-gray-300 hover:text-white'}`}
            aria-pressed={activeLanguage === code}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}

